import React from 'react'
import './styles'

# components
import Spinner    from '/components/spinner'
import Empty      from '/components/empty'
import Timeline   from '/components/timeline'
import HeroStats  from '/components/hero-stats'
import StateLabel from '/components/state-label'
import Datetime   from '/components/datetime'
import UserCard   from '/components/user-card'
import Price      from '/components/price'
import ExternalLink from '/components/external-link'

import { withTransfer } from './queries'

export default \
withTransfer \
class Summary extends React.Component

  render: ->
    return <Spinner/> if @props.transferLoading
    return <Empty name="Transfer" /> unless @props.transfer?.id

    <div className="Summary">
      {@overview()}
      {@timeline()}
      {@details()}
    </div>

  overview: ->
    transfer = @props.transfer

    <div className="transfer-overview">
      <HeroStats data={[
          name: "State"
          value: <StateLabel model={transfer}/>
        ,
          name: "Recipient"
          value: transfer.name
          tooltip: transfer.email
        ,
          name: "Started"
          value: <Datetime date={transfer.created_at} inline={true}/>
        ]}/>
    </div>

  timeline: ->
    <div className="lifecycle">
      <h2>Lifecycle</h2>
      <div className="panel panel-default">
        <div className="panel-body">
          <Timeline events={@props.transfer.timeline or []}/>
        </div>
        <div className="panel-footer">
          <small>
            Opens and clicks come from SES with no timestamps, so they're counted
            against the email rather than shown as their own steps. They're only
            recorded in production.
          </small>
        </div>
      </div>
    </div>

  details: ->
    transfer  = @props.transfer
    cost_item = transfer.original_cost_item

    <div className="details">

      <div className="detail">
        <h3>Recipient</h3>
        <div className="panel panel-default">
          <div className="panel-body">
            <dl>
              <dt>Invited</dt>
              <dd>{transfer.name} &lt;{transfer.email}&gt;</dd>
              <dt>Accepted by</dt>
              <dd>
                {if transfer.accepted_by_name
                  "#{transfer.accepted_by_name} <#{transfer.accepted_by_email}>"
                else
                  <span className="muted">—</span>
                }
              </dd>
            </dl>
            {if transfer.ticket?.user
              <UserCard user={transfer.ticket.user} />
            }
          </div>
        </div>
      </div>

      <div className="detail">
        <h3>Sender</h3>
        <div className="panel panel-default">
          <div className="panel-body">
            {if cost_item?.buyer
              <UserCard user={cost_item.buyer} />
            else
              <span className="muted">Unknown</span>
            }
          </div>
        </div>
      </div>

      <div className="detail">
        <h3>Event</h3>
        <div className="panel panel-default">
          <div className="panel-body">
            <dl>
              <dt>Listing</dt>
              <dd>{cost_item?.listing?.title}</dd>
              <dt>Starts</dt>
              <dd><Datetime date={cost_item?.event?.start_time} inline={true}/></dd>
            </dl>
          </div>
        </div>
      </div>

      <div className="detail">
        <h3>Cost Items</h3>
        <div className="panel panel-default">
          <div className="panel-body">
            <dl>
              <dt>Original</dt>
              <dd>
                {@costItemLink cost_item?.id}
                {if cost_item
                  <span className="ci-meta">
                    {cost_item.name}
                    {' · '}
                    <Price amount={cost_item.src_price} currency={cost_item.src_currency}/>
                  </span>
                }
              </dd>
              <dt>New</dt>
              <dd>
                {if transfer.new_cost_item_id
                  @costItemLink transfer.new_cost_item_id
                else
                  <span className="muted">not created yet</span>
                }
              </dd>
              <dt>Order</dt>
              <dd>
                {if cost_item?.ticket
                  <ExternalLink url={"#{process.env.WEB}/dashboard/ticket/#{cost_item.ticket.id}"}/>
                }
              </dd>
            </dl>
          </div>
        </div>
      </div>

    </div>

  costItemLink: (id) ->
    return <span className="muted">—</span> unless id
    <a className="btn btn-default" href={"#{process.env.MULTIVERSE}/cost_items/#{id}"} target="_blank" rel="noopener noreferrer">
      <samp>...{id.slice -6}</samp>
    </a>
